// date.utils.ts
import { format } from "date-fns";

/**
 * Formats a UTC ISO date string into the browser's local timezone.
 * Handles null/undefined values gracefully and formats as "MMM dd, yyyy hh:mm a".
 * Adds 'Z' suffix if missing to ensure proper UTC parsing.
 * 
 * @param {string | null | undefined} timeString - UTC ISO date string to format
 * @returns {string} Formatted date string in local timezone, or "—" if input is null/undefined, or original string if parsing fails
 * 
 * @example
 * ```tsx
 * const formatted = formatDate("2024-01-15T10:30:00");
 * // Returns: "Jan 15, 2024 10:30 AM" (in local timezone)
 * 
 * const empty = formatDate(null);
 * // Returns: "—"
 * ```
 */
export const formatDate = (timeString: string | null | undefined): string => {
  if (!timeString) return "—";

  try {
    const formatted = format(timeString+`Z`, "MMM dd, yyyy hh:mm a");
    return formatted
  } catch {
    return timeString;
  }
};
